import { RootState } from 'store';
import apiUsersAdapter from 'store/adapters/superadmins-adapter';
import IUser from 'types/superadmin/ISuperAdmin';

export const apiUsersSelectors = apiUsersAdapter.getSelectors((state: RootState) => state.apiUsers);
export const apiUsersSelector = apiUsersSelectors.selectAll;
export const apiUsersErrorSelector = (state: RootState): boolean => state.apiUsers.superAdminsError;
export const accountManagersSelector = (state: RootState): IUser[] => state.apiUsers.accountManagers;

export const apiUsersLoadingSelector = (state: RootState): boolean => state.apiUsers.loading;
